import {Box} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Leave, LeaveEntity } from "../../../../entriesAPI";
import LeaveEntityDateRangePicker from "../../../Shared/LeaveEntityDateRangePicker";
import ContinuePrevious from "../../LeaveDetailsComponents/DetailsParts/ContinuePrevious";
import PreviousLeaves from "../../LeaveDetailsComponents/DetailsParts/PreviousLeaves";
import LeaveAttachments from "../../../Shared/LeaveAttachments";
import { AbsenceListEntry } from "../../AbsenceHoursList/AbsenceHoursList";
import { isAllowedContinuationOfType } from "../../../Shared/functions";

interface Props {
  leaveEntity: LeaveEntity;
  setLeaveEntity: (val: LeaveEntity) => void;
  entries: AbsenceListEntry[];
  setEntries: (val: AbsenceListEntry[]) => void;
  updateLeaveEntity: (
    key: string,
    value:
      | string
      | { startDate: string | null; endDate: string | null }
      | null
      | Leave,
  ) => void;
  inputErrors: { [code: string]: boolean };
  setInputErrors: (inputErrors: { [code: string]: boolean }) => void;
  showAttachments: boolean;
  disableDatePicker?: boolean;
  pendingAttachments?: File[];
  onPendingAttachmentsChange?: (files: File[]) => void;
}

const ToGeneralLeave = ({
  leaveEntity,
  setLeaveEntity,
  entries,
  setEntries,
  updateLeaveEntity,
  inputErrors,
  setInputErrors,
  showAttachments,
  disableDatePicker = false,
  pendingAttachments,
  onPendingAttachmentsChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginTop: "20px",
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.52)",
            marginRight: "10px",
            marginBottom: "5px",
          }}
        >
          {t("hourEntries:absenceDate")}
        </Box>

        <LeaveEntityDateRangePicker
          dateRange={leaveEntity.dateRange}
          inputErrors={inputErrors}
          setInputErrors={setInputErrors}
          updateLeaveEntity={updateLeaveEntity}
          disabled={disableDatePicker}
        />
      </Box>
      {showAttachments && (
        <LeaveAttachments
          entries={entries}
          setEntries={setEntries}
          leaveEntity={leaveEntity}
          setLeaveEntity={setLeaveEntity}
          pendingAttachments={pendingAttachments}
          onPendingAttachmentsChange={onPendingAttachmentsChange}
        />
      )}

      {isAllowedContinuationOfType(leaveEntity.type) && (
        <ContinuePrevious
          leaveEntity={leaveEntity}
          updateLeaveEntity={updateLeaveEntity}
        />
      )}

      {leaveEntity.previousLeaves.order.length > 0 &&
        isAllowedContinuationOfType(leaveEntity.type) && (
          <PreviousLeaves
            leaveEntity={leaveEntity}
            updateLeaveEntity={updateLeaveEntity}
          />
        )}
    </>
  );
};

export default ToGeneralLeave;
